<div class="container">
    <div class="d-flex align-items-center justify-content-center monitor">
        <mat-card class="col-lg-6">

            <div class="row">
                <div class="col-lg-12">
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <div class="mt-4 mb-4">
                            <img [src]="urlLogo" width="240" alt="">
                        </div>
                        <div class="mt-4 mb-4 col-lg-8 text-center">
                            <h1>{{ 'Exito_Texto1' | i18next}} <span class="sort">{{codigoComunicacion}}</span></h1>
                        </div>
                        <div class="mt-4 mb-4 col-lg-8 text-center">
                            <p *ngIf="modoEnvio === 0">{{ 'Exito_Texto2' | i18next}}</p>
                            <p *ngIf="modoEnvio === 1">{{ 'Exito_TextoWhatsapp' | i18next}}</p>
                            <p *ngIf="modoEnvio === 2">{{ 'Exito_TextoFisico' | i18next}}</p>
                        </div>
                    </div>
                </div>
            </div>

        </mat-card>
    </div>

</div>
